export function Footer(){
    return(
        <div className='footer'>
            <div style={{marginTop:'20px'}}>
            <i style={{color:'white'}} className="fa fa-facebook fa-2x" aria-hidden="true"></i>
            <i style={{color:'white'}} className="fa fa-linkedin-square fa-2x" aria-hidden="true"></i>
            <i style={{color:'white'}} className="fa fa-twitter fa-2x" aria-hidden="true"></i>
            <i style={{color:'white'}} className="fa fa-google-plus fa-2x" aria-hidden="true"></i>
          </div>
          <h1 style={{color:'white',borderBottom:'none',fontSize:'40px'}}>BookMyShow</h1>
            <p style={{color:'white'}}>copyright @ 2021</p>
        </div>
    )
}